import { uuid25 } from "../../../uuid/dist/uuid25.js";
import { query } from "../../../erd-editor-schema/dist/query/index.js";
import { ColumnOption } from "../../../constants/schema.js";
import { createColumn } from "../../../utils/collection/tableColumn.entity.js";
import { addColumnAction, changeColumnPrimaryKeyAction } from "../table-column/atom.actions.js";
import { bHas } from "../../../utils/bit.js";
import { addRelationshipAction } from "./atom.actions.js";
import { toForeignKeyActions } from "./fkColumns.js";
//#region src/engine/modules/relationship/generator.actions.ts
var addRelationshipAction$ = (startTableId, endTableId, relationshipType, referentialActions = {}) => function* ({ doc: { tableIds, domainIds }, collections, settings: { database } }) {
	const tables = query(collections).collection("tableEntities").selectByIds(tableIds);
	const startTable = tables.find(({ id }) => id === startTableId);
	const endTable = tables.find(({ id }) => id === endTableId);
	if (!startTable || !endTable) return;
	const columnCollection = query(collections).collection("tableColumnEntities");
	const primaryKeys = columnCollection.selectByIds(startTable.columnIds).filter(({ options }) => bHas(options, ColumnOption.primaryKey));
	const newPrimaryKey = primaryKeys.length ? null : createColumn({ tableId: startTable.id });
	const startColumns = newPrimaryKey ? [newPrimaryKey] : primaryKeys;
	const endColumnIds = startColumns.map(() => uuid25());
	yield [
		...newPrimaryKey ? [addColumnAction({
			id: newPrimaryKey.id,
			tableId: startTable.id
		}), changeColumnPrimaryKeyAction({
			id: newPrimaryKey.id,
			tableId: startTable.id,
			value: true
		})] : [],
		...toForeignKeyActions(startColumns, endTable.id, endColumnIds, {
			startTableName: startTable.name,
			endColumnNames: columnCollection.selectByIds(endTable.columnIds).map(({ name }) => name),
			database,
			domainIds
		}),
		addRelationshipAction({
			id: uuid25(),
			relationshipType,
			...referentialActions,
			start: {
				tableId: startTable.id,
				columnIds: startColumns.map(({ id }) => id)
			},
			end: {
				tableId: endTable.id,
				columnIds: endColumnIds
			}
		})
	];
};
var actions$ = { addRelationshipAction$ };
//#endregion
export { actions$, addRelationshipAction$ };
